
import auth from '@modules/auth/authController.js';
import appNav from "./appNav.js";

class NavigationController {
    constructor() {
    }
}

const navigationController = new NavigationController();
export default navigationController;